module.exports = __webpack_public_path__ + "static/media/eventage-logo.4b894493.png";